var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2313 18.6909C10.7955 17.5794 11.6566 16.6459 12.7189 15.9938C13.7813 15.3418 15.0035 14.9966 16.25 14.9966C17.4965 14.9966 18.7187 15.3418 19.7811 15.9938C20.8434 16.6459 21.7045 17.5794 22.2688 18.6909",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 21C21.2206 21 25.25 16.9706 25.25 12C25.25 7.02944 21.2206 3 16.25 3C11.2794 3 7.25 7.02944 7.25 12C7.25 16.9706 11.2794 21 16.25 21Z",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15C18.3211 15 20 13.3211 20 11.25C20 9.17893 18.3211 7.5 16.25 7.5C14.1789 7.5 12.5 9.17893 12.5 11.25C12.5 13.3211 14.1789 15 16.25 15Z",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.a46f3a43878ecc80e70fcfd37d634d5c.svg";
export { ForwardRef as ReactComponent };